var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-row',{staticClass:"m-0",attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"p-0",attrs:{"cols":"auto"}},[_c('NavBar')],1),_c('b-col',{staticClass:"p-0"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }